import { Typography } from '@mui/material';
import { ComponentSharedPageBanner } from '@peerless/data-access/strapi';
import { getColorConversion, getImageProperties, ImageBanner } from '../../lib';
import { useMemo } from 'react';

interface Props {
  block: ComponentSharedPageBanner;
}

export const DynamicPageBanner: React.FC<Props> = ({ block }: Props) => {
  const { title, image: background, textColor } = block;
  const image = useMemo(() => {
    if (!background) return undefined;
    const properties = getImageProperties(background);
    return { src: properties.url, height: properties.height, width: properties.width };
  }, [background]);
  return (
    <ImageBanner
      background={image}
      align="flex-end"
      justify="flex-end"
      sx={{
        minHeight: {
          xs: image ? '25vh' : 'auto',
          lg: image ? '35vh' : 'auto',
          xl: image ? '40vh' : 'auto',
        },
      }}
    >
      <Typography
        variant={'h1'}
        color={getColorConversion(textColor)}
        className="header-underline"
        marginBottom={0}
      >
        {title}
      </Typography>
    </ImageBanner>
  );
};
